<button
  class="bps-trigger"
  mat-stroked-button
  [mdePopoverTriggerFor]="anglePopover"
  mdePopoverTriggerOn="click"
  [disabled]="disabled">
  <csl-base-point-thumbnail [showAxis]="showAxis" [active]="value"></csl-base-point-thumbnail>
</button>

<mde-popover #anglePopover="mdePopover" [mdePopoverOverlapTrigger]="false">
  <div class="container mat-elevation-z8">
    <div class="selector-wrapper">
      <div class="selector-outline"></div>
      <div class="selector-cross-outline" *ngIf="activeSchema.c">
        <div class="line line1"></div>
        <div class="line line2"></div>
      </div>
      <button
        type="button"
        data-testid="btnTl"
        (click)="valueChange.emit('tl')"
        class="btn tl"
        *ngIf="activeSchema.tl"></button>
      <button
        type="button"
        data-testid="btnTr"
        (click)="valueChange.emit('tr')"
        class="btn tr"
        *ngIf="activeSchema.tr"></button>
      <button
        type="button"
        data-testid="btnBr"
        (click)="valueChange.emit('br')"
        class="btn br"
        *ngIf="activeSchema.br"></button>
      <button
        type="button"
        data-testid="btnBl"
        (click)="valueChange.emit('bl')"
        class="btn bl"
        *ngIf="activeSchema.bl"></button>
      <button type="button" (click)="valueChange.emit('c')" class="btn c" *ngIf="activeSchema.c"></button>

      <div class="axis tl">
        <div class="ax x"></div>
        <div class="ax y"></div>
        <div class="x caption">x</div>
        <div class="y caption">y</div>
        <div class="x arrow"></div>
        <div class="y arrow"></div>
      </div>
      <div class="axis tr">
        <div class="ax x"></div>
        <div class="ax y"></div>
        <div class="x caption">x</div>
        <div class="y caption">y</div>
        <div class="x arrow"></div>
        <div class="y arrow"></div>
      </div>
      <div class="axis br">
        <div class="ax x"></div>
        <div class="ax y"></div>
        <div class="x caption">x</div>
        <div class="y caption">y</div>
        <div class="x arrow"></div>
        <div class="y arrow"></div>
      </div>
      <div class="axis bl">
        <div class="ax x"></div>
        <div class="ax y"></div>
        <div class="x caption">x</div>
        <div class="y caption">y</div>
        <div class="x arrow"></div>
        <div class="y arrow"></div>
      </div>
    </div>
  </div>
</mde-popover>
